export default __webpack_public_path__ + "static/media/partner2.83cb4ca9.svg";